import styled from '@emotion/styled'
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar'
import ViewSidebarOutlinedIcon from '@mui/icons-material/ViewSidebarOutlined'
import { memo } from 'react'
import type { IconProps } from '.'

interface IResizableIcon {
    size: number | string
}

const ResizableFilledIcon = styled(ViewSidebarIcon)(
    ({ size }: IResizableIcon) => ({
        fontSize: size,
    }),
)

const ResizableOutlinedIcon = styled(ViewSidebarOutlinedIcon)(
    ({ size }: IResizableIcon) => ({
        fontSize: size,
    }),
)

const Sidebar = memo((props: IconProps) => {
    const { color, filled, size, title } = props
    const Icon = filled ? ResizableFilledIcon : ResizableOutlinedIcon
    return (
        <Icon
            data-testid="Icon__ViewSidebar"
            css={{ color }}
            htmlColor={color}
            size={size}
            titleAccess={title}
        />
    )
})

export default Sidebar
